import React from 'react'

import clsx from 'clsx'

import YoutubeVideo from 'components/YoutubeVideo'
import { getYoutubeId } from 'helpers/resources'

import classes from './ContentInlineFrame.module.scss'

const ContentInlineFrame = ({ contentUrl, width, height }) => {
  const youtubeId = getYoutubeId(contentUrl)
  const aspectRatio = !!width && !!height ? width / height : 1

  return (
    <div
      className={clsx('ContentInlineFrame', { [classes.inlineFrame]: !youtubeId })}
      style={!youtubeId ? { aspectRatio: `${aspectRatio}` } : {}}
    >
      {youtubeId ? (
        <YoutubeVideo video={{ videoId: youtubeId }} loading="lazy" />
      ) : (
        <iframe
          loading="lazy"
          className={classes.iframe}
          src={contentUrl}
          title="ContentInlineIFrame"
          aria-label="ContentInlineIFrame"
          role="presentation"
        />
      )}
    </div>
  )
}

export default ContentInlineFrame
